import { Descriptions } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { IntroducedThroughUndetermined } from "@/molecules/IntroducedThroughUndetermined"
import {
  AiRelatedInsightContent,
  AiRelatedInsightLabel
} from "@/organisms/Drawers/components/AiRelatedInsight"
import { OverviewCardTemplate } from "@/organisms/Drawers/components/PackageDrawer/components/OverviewCardTemplate"
import { InsightsTriageCell } from "@/pages/TriagePage/components/molecules/InsightsTriageCell"
import { IntroduceThroughInsightsICell } from "@/pages/TriagePage/components/molecules/IntroduceThroughInsightsICell"

import styles from "@/organisms/Drawers/Drawers.module.scss"

export const InsightsCard = (props: { record: any }) => {
  const { t } = useTranslation()
  const { record } = props
  if (!record) return null

  const { introducedThroughInsights, riskInsights } = record
  const someIntroducedThroughInsightsExist =
    !introducedThroughInsights.allFalse &&
    Object.keys(introducedThroughInsights).some(
      (key) =>
        !!introducedThroughInsights[
          key as keyof typeof introducedThroughInsights
        ]
    )

  const items = [
    {
      label: (
        <Descriptions.Label>
          {t("general.introducedThrough")}
        </Descriptions.Label>
      ),
      className: styles.introducedThroughInsights,
      children: someIntroducedThroughInsightsExist ? (
        IntroduceThroughInsightsICell({ tag: true, t })({
          ...introducedThroughInsights
        })
      ) : (
        <IntroducedThroughUndetermined />
      )
    },
    {
      label: <AiRelatedInsightLabel />,
      children: (
        <AiRelatedInsightContent
          aiRelated={riskInsights.aiRelated}
          aiPackageCategory={riskInsights.aiPackageCategory}
        >
          {InsightsTriageCell(t)({
            tag: true,
            aiRelated: !!riskInsights.aiRelated
          })}
        </AiRelatedInsightContent>
      )
    }
  ]

  return <OverviewCardTemplate title="Insights" items={items} />
}
